import { useState } from "react";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

const EXCEPTION_TYPE = /^[\w.`+]*(?:Exception|Error):\s*/;
const STATUS_CODE = /^\((\d{3}[^)]*)\)\s*/;

const parseMirrorError = (error: string) => {
    const lines = error.replace(/\r\n/g, "\n").split("\n");
    const headline = lines[0].trim().replace(EXCEPTION_TYPE, "");
    const status = STATUS_CODE.exec(headline);

    return {
        code: status ? status[1] : "",
        message: status ? headline.slice(status[0].length) : headline,
        trace: lines.slice(1).join("\n").trimEnd(),
    };
};

type Props =
    {
        error: string
    }

export default function StoreReportMirrorError({ error }: Props) {
    const [showTrace, setShowTrace] = useState(false);
    const { code, message, trace } = parseMirrorError(error);

    return (
        <div className="report-mirror-error">
            <div className="report-mirror-error__bar">
                <ErrorOutlineRoundedIcon fontSize="small" className="report-mirror-error__icon" />
                <span className="report-mirror-error__label">Mirror error</span>
                {code && <span className="report-mirror-error__code">{code}</span>}
                <span className="report-mirror-error__message" title={message}>{message}</span>
                {trace && (
                    <button
                        type="button"
                        className={`report-mirror-error__toggle ${showTrace ? "is-open" : ""}`}
                        onClick={() => setShowTrace(!showTrace)}
                        aria-expanded={showTrace}
                    >
                        Stack trace
                        <ExpandMoreRoundedIcon fontSize="small" />
                    </button>
                )}
            </div>
            {showTrace && trace && <pre className="report-mirror-error__trace">{trace}</pre>}
        </div>
    );
}
